import { graphql } from "react-relay";

export const QUERY_FRAGMENT = graphql`
	query selectDiscountCodeField_Query(
		$first: Int
		$after: String
		$code: String
		$filterByDiscountTypeKind: DiscountTypeKindInput
	) {
		Admin {
			Billing {
				searchDiscountCodes(
					first: $first
					after: $after
					code: $code
					filterByDiscountTypeKind: $filterByDiscountTypeKind
				) {
					__id
					pageInfo {
						endCursor
						hasPreviousPage
						hasNextPage
						startCursor
					}
					edges {
						node {
							id
							code
							numUsages
							createdAt
						}
					}
				}
			}
		}
	}
`;
